// src/features/marketResearch/components/PrintHeader.tsx
import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export const PrintHeader: React.FC = () => {
  const theme = useTheme();
  return (
    <Box component="header" sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: 56,
      bgcolor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider}`,
      px: 2,
      display: 'flex',
      alignItems: 'center',
      '@media print': { display: 'flex' },
      '@media screen': { display: 'none' },
    }}>
      <img src="/logo.png" alt="Logo" style={{ height: 32, marginRight: theme.spacing(1) }} />
      <Typography variant="h6" sx={{ flexGrow: 1, color: theme.palette.text.primary }}>
        Hotel Market Research
      </Typography>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
        {new Date().toLocaleDateString()}
      </Typography>
    </Box>
  );
};
